import HTTP from '../HTTP';

const URL_BASE = 'app/Role/';

export async function getAll() {
  const response = await HTTP.get(URL_BASE + 'GetAllAsync', { params: { MaxResultCount: 999 } });
  return response;
}

export async function getAllPermissions() {
  const response = await HTTP.get(URL_BASE + 'GetAllPermissions');
  return response;
}

export async function create(parameters) {
  const response = await HTTP.post(URL_BASE + 'CreateAsync', parameters);
  return response;
}

export async function getRoleForEdit(id) {
  const response = await HTTP.get(URL_BASE + 'GetRoleForEdit', { params: { id: id } });
  return response;
}

export async function update(parameters) {
  const response = await HTTP.put(URL_BASE + 'UpdateAsync', parameters);
  return response;
}
